// ==================== CUSTOMER-ONLY OUTLET ====================
// Pathless layout route for customer screens a sub-account must not open
// (everything except the dashboard, the WhatsApp inbox and profile/organization settings).
// Everyone else just renders the nested routes.

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { ROUTES } from '../../constants';

export const CustomerOnlyOutlet = () => {
  const { user } = useAuth();

  if (user?.role === 'SUB_CUSTOMER') {
    return <Navigate to={ROUTES.CUSTOMER.DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default CustomerOnlyOutlet;
